import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';
import { Content } from '../models/content';
import { CourseStep } from '../models/course';

const TASK_TYPE_MAP = {
  assessment: 'Assessment',
  download: 'Download',
  video: 'Video',
  audio: 'Video',
  documentViewer: 'DocumentViewer',
} as const;

export const createContentStep = (
  courseId: string,
  contentItems: Content[],
  order: number,
  stepType: 'assessment' | 'download' | 'video' | 'audio' | 'documentViewer',
  initiatingUserId: string
): Promise<CourseStep[]> => {
  const tasks = contentItems.map(item => ({
    taskId: uuid.generate(),
    taskName: item.name,
    content: item.id,
    _type: TASK_TYPE_MAP[stepType],
  }));

  return submitCommand(
    courseId,
    {
      id: courseId,
      initiatingUserId: initiatingUserId,
      order: order,
      tasks: tasks,
    },
    'AddTasksToTaskList',
    'TasksAddedToTaskList',
    'TasksFailedToAddToTaskList'
  ).then(() =>
    tasks.map((task, index) => ({
      _id: { id: task.taskId },
      _type: TASK_TYPE_MAP[stepType],
      taskName: task.taskName,
      order: order + index,
    }))
  );
};
